import { observer } from 'mobx-react-lite'
import { NodeProps } from 'reactflow'
import { metersToPixels, RAIL_TRACK_HEIGHT } from '../../helpers/yard-view.utils'
import { RailTrackWithActions } from '../../models/yard-view.model'
import { RailTrackPattern } from '../atoms/YardNodes/Railtrack/RailTrackPattern'
import { FocusWrapper } from '../molecules/FocusWrapper'
import { RailTrackHeader } from '../molecules/RailTrackHeader'
import { RotatableNodeWrapper } from '../molecules/RotatableNodeWrapper'

export const RailTrackNode = observer(({ data }: NodeProps<RailTrackWithActions>) => {
  const {
    id,
    name,
    length,
    isEditable,
    focused,
    showNodeHeaders,
    layoutPosition,
    onRotate,
    onEdit,
    onFocus,
    onDelete,
  } = data

  return (
    <RotatableNodeWrapper
      rotation={layoutPosition.rotation}
      enabled={focused && isEditable}
      onRotationEnd={angle => onRotate(id, angle)}
      header={
        focused || showNodeHeaders ? (
          <RailTrackHeader
            id={id}
            name={name}
            length={length ?? 10}
            focused={focused}
            isEditable={isEditable}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        ) : undefined
      }
    >
      <FocusWrapper
        focused={focused}
        isEditable={isEditable}
        onFocus={() => onFocus(id)}
        height={RAIL_TRACK_HEIGHT}
        width={metersToPixels(length ?? 10)}
      >
        <RailTrackPattern />
      </FocusWrapper>
    </RotatableNodeWrapper>
  )
})
